import fetchData from "@/utils/fetchData";

// Wishes are MakeMeA's credits: makes use them up and more can be bought
const request = (endpoint) =>
  fetchData(`wishes/${endpoint}`, {}, false, false, false);

export default {
  name: "wishes",
  namespaced: true,
  state: {
    balance: null,
    costs: { make: 1, research: 1, image: 2 },
    pack: { wishes: 50, price: 500, currency: "gbp" },
    canBuy: false,
    // "" when closed, otherwise "info", "empty" or "thanks"
    modal: "",
    buying: false,
    error: "",
    // Where the wishes went, newest first; null until loaded
    history: null,
    historyError: "",
  },
  mutations: {
    SET_BALANCE(state, payload) {
      state.balance = payload;
    },
    SET_DETAILS(state, { costs, pack, canBuy }) {
      if (costs) state.costs = costs;
      if (pack) state.pack = pack;
      state.canBuy = Boolean(canBuy);
    },
    SET_MODAL(state, payload) {
      state.modal = payload;
    },
    SET_BUYING(state, payload) {
      state.buying = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },
    SET_HISTORY(state, payload) {
      state.history = payload;
    },
    SET_HISTORY_ERROR(state, payload) {
      state.historyError = payload;
    },
  },
  actions: {
    async fetchBalance({ commit, rootState }) {
      if (!rootState.auth.loggedIn) {
        commit("SET_BALANCE", null);
        return null;
      }
      const { response } = await request("balance");
      if (
        response.status === 201 &&
        typeof response.result?.wishes === "number"
      ) {
        commit("SET_BALANCE", response.result.wishes);
        commit("SET_DETAILS", response.result);
        return response.result.wishes;
      }
      return null;
    },
    setBalance({ commit }, balance) {
      if (typeof balance === "number") {
        commit("SET_BALANCE", balance);
      }
    },
    openModal({ commit, dispatch }, reason = "info") {
      commit("SET_ERROR", "");
      commit("SET_MODAL", reason);
      dispatch("fetchBalance");
    },
    closeModal({ commit }) {
      commit("SET_MODAL", "");
    },
    async fetchHistory({ commit }) {
      commit("SET_HISTORY_ERROR", "");
      commit("SET_HISTORY", null);
      const { response } = await request("history");
      if (response.status === 201 && Array.isArray(response.result?.history)) {
        commit("SET_HISTORY", response.result.history);
        commit("SET_BALANCE", response.result.wishes);
      } else {
        commit("SET_HISTORY", []);
        commit("SET_HISTORY_ERROR", "We couldn't load your history");
      }
    },
    async buy({ commit }) {
      commit("SET_ERROR", "");
      commit("SET_BUYING", true);
      const { response } = await request("checkout");
      if (response.status === 201 && response.result?.url) {
        window.location.assign(response.result.url);
        return;
      }
      commit("SET_BUYING", false);
      commit(
        "SET_ERROR",
        response.result?.message ||
          "We couldn't start the payment, please try again"
      );
    },
    // Back from Stripe: Stripe tells us about the payment separately, so keep
    // checking for the new wishes for a little while
    async purchaseReturned({ commit, dispatch, state }, status) {
      if (status !== "success") return;
      commit("SET_MODAL", "thanks");
      const before = state.balance;
      for (let attempt = 0; attempt < 10; attempt += 1) {
        const balance = await dispatch("fetchBalance");
        if (balance !== null && before !== null && balance > before) return;
        if (before === null && balance !== null && attempt > 2) return;
        await new Promise((resolve) => setTimeout(resolve, 2000));
      }
    },
  },
  getters: {
    priceLabel(state) {
      try {
        return new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: state.pack.currency.toUpperCase(),
        }).format(state.pack.price / 100);
      } catch {
        return `${state.pack.price / 100}`;
      }
    },
  },
};
